import React, {Component} from 'react';
import {Layout, Menu, Icon} from 'antd';
import {Link, Route, Switch, Redirect} from 'react-router-dom';
import Iconz from "../components/Iconz";
import Head from "../components/Head";
import {app, config} from "../app";
import Trainadd from "./task/Trainadd";
import '../css/task.css';
import Trainconfirm from "./task/Trainconfirm";
import PreparationOut from "./task/PreparationOut";
import TrainingIn from "./task/TrainingIn";
import TaskCorrection from "./task/TaskCorrection";

const {Sider, Content, Header} = Layout;

function checkMenu(path) {
    let key = '1';
    switch (path) {
        case '/task/trainadd':
            key = '2';
            break;
        case '/task/trainconfirm':
            key = '7';
            break;
        case '/task/report-out':
            key = '9';
            break;
        case '/task/train-in':
            key = '10';
            break;
        case '/task/task-correction':
            key = '11';
            break;
    }
    return key;
}

class Task extends Component {
    constructor(props) {
        super(props);
        const path = props.location.pathname;
        this.state = {
            menu_current: checkMenu(path),
            rights: app.getData('rights'),
        };
    }

    handleMenuClick = (e) => {
        const key = e.key, {history} = this.props;
        this.setState({ menu_current: key }, ()=>{
            switch (key) {
                case '1':
                    history.push(`/task`);
                    break;
                case '2':
                    history.push('/task/trainadd');
                    break;
                case '3':
                    history.push('/task');
                    break;
                case '4':
                    history.push('/task');
                    break;
                case '5':
                    history.push('/task');
                    break;
                case '6':
                    history.push('/task');
                    break;
                case '7':
                    history.push('/task/trainconfirm');
                    break;
                case '8':
                    history.push('/task');
                    break;
                case '9':
                    history.push('/task/report-out');
                    break;
                case '10':
                    history.push('/task/train-in');
                    break;
                case '11':
                    history.push('/task/task-correction');
                    break;
            }
        });
    }

    render() {
        const isLogin = app.checkLogin(), {rights} = this.state;
        if (isLogin) {
            return (<Redirect to="/"/>);
        } else {
            return (
                <Layout className="task-page ranks">
                    <Sider style={{width: 200, background: "#3C474F"}}>
                        <div className="r_left_logo">
                            <Iconz type="icon-logo_" size={48}/>
                        </div>
                        <Menu
                            className="r_left_menu"
                            theme="dark"
                            onSelect={this.handleMenuClick}
                            selectedKeys={[this.state.menu_current]}
                            mode="inline"
                            style={{background: "#3C474F"}}
                        >
                            {/*<Menu.Item key="1"><Iconz type="icon-Civil_administration" size={14}></Iconz> 报备</Menu.Item>*/}
                            {[1, 3].indexOf(rights) === -1 ? '' : <Menu.Item key="2"><Icon type="plus"/> 添加培训任务</Menu.Item>}
                            {/*<Menu.Item key="3"><Icon type="notification" /> 案件通知</Menu.Item>*/}
                            {/*<Menu.Item key="4"><Icon type="file-text" /> 上报内容</Menu.Item>*/}
                            {/*<Menu.Item key="5"><Icon type="close" /> 任务纠错</Menu.Item>*/}
                            {/*<Menu.Item key="6"><Icon type="edit" /> 更改出队信息</Menu.Item>*/}
                            {[1, 3].indexOf(rights) === -1 ? '' : <Menu.Item key="7"><Icon type="check"/> 救援任务确认</Menu.Item>}
                            {/*<Menu.Item key="8"><Icon type="check" /> 培训任务确认</Menu.Item>*/}
                            {[4].indexOf(rights) === -1 ? '' : <Menu.Item key="9"><Icon type="logout"/> 出队报备</Menu.Item>}
                            <Menu.Item key="10"><Icon type="plus-circle-o"/> 参加培训</Menu.Item>
                            <Menu.Item key="11"><Icon type="close-circle-o"/> 任务纠错</Menu.Item>
                            {/*{isLogin ? '' : <Menu.Item key="2"><Iconz type="icon-bianji" size={18}></Iconz> 个人信息编辑</Menu.Item>}*/}
                        </Menu>
                    </Sider>
                    <Layout>
                        <Header className="r_right_head"><Head notLogin={true} background="#3F89C1" height={78}
                                                               history={this.props.history}/></Header>
                        <Content className="r_right_content">
                            <Switch>
                                {[1, 3].indexOf(rights) === -1 ? '' : [
                                    (<Route key="1" exact path="/task/trainadd" component={Trainadd}/>),
                                    (<Route key="2" exact path="/task/trainconfirm" component={Trainconfirm}/>)
                                ]}
                                {[4].indexOf(rights) === -1 ? '' : <Route exact path="/task/report-out" component={PreparationOut}/>}
                                <Route exact path="/task/train-in" component={TrainingIn}/>
                                <Route exact path="/task/task-correction" component={TaskCorrection}/>
                                <Route exact path="/task" component={TrainingIn}/>
                                <Route render={() => <Redirect to='/task'/>}/>
                            </Switch>
                        </Content>
                    </Layout>
                </Layout>
            );
        }
    }
}

export default Task;



// WEBPACK FOOTER //
// ./src/routes/Task.jsx